import React, { useMemo } from "react";
import Currency from "../general/Currency";
import { useTranslation } from "react-i18next";
import { adjustmentTypes } from "../general/constants";
import { useTicket } from "../../store/Store";
import DiscountAdjustment from "./adjustmentTypeComponents/DiscountAdjustment";
import { getBalanceDue } from "../general/AppHelpers";

const AdjustmentItem = ({ adjustment, taxes }) => {
  const { t } = useTranslation();

  const { data: ticketData } = useTicket();
  const { deposit } = ticketData?.access_token?.data?.payload || {
    deposit: false,
  };
  const balanceDue = getBalanceDue(ticketData);

  const adjustmentPrice = useMemo(() => {
    if (adjustment?.in_package) {
      return (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100">
          {t("discounts.in_package")}
        </span>
      );
    }

    if (adjustment?.in_membership) {
      return (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100">
          {t("discounts.in_membership")}
        </span>
      );
    }

    return (
      <Currency
        value={adjustment.amount_before_discount || adjustment.amount}
      />
    );
  }, [adjustment, t]);

  const staffInformation = useMemo(() => {
    if (adjustment?.adjustable_type !== adjustmentTypes.slotVariation) {
      return null;
    }

    return (
      <span className="inline-flex gap-1 pl-0.5 text-sm text-black-light">
        | {t("ticket.staff")}:{" "}
        {adjustment.staff?.map((staff) => staff).join(", ")}
      </span>
    );
  }, [adjustment, t]);

  const promoDiscountItems = ticketData?.resource?.discount_items
    ?.filter((item) => item.discountable_id === adjustment?.adjustable_id)
    ?.map((item) => {
      return (
        <DiscountAdjustment
          label={item.promo_code || item.promo_name}
          amount={item.amount}
          type="promo"
        />
      );
    });

  if (!adjustment) {
    return null;
  }

  return (
    <>
      <div className="flex w-full text-sm text-black justify-between items-center">
        {deposit ? (
          <>
            <div className="pl-8 pr-3 flex-row align-center">
              {`${t("deposit.title")} - ${adjustment.label}` ||
                "Unlabeled Item"}{" "}
              {staffInformation}
            </div>
            <div className="whitespace-nowrap px-3">
              <Currency value={balanceDue} />
            </div>
          </>
        ) : (
          <>
            <div className="pl-8 pr-3 flex-row align-center">
              {adjustment.label || "Unlabeled Item"} {staffInformation}
            </div>
            <div className="whitespace-nowrap px-3">{adjustmentPrice}</div>
          </>
        )}
      </div>

      {/* Display associated discount items */}
      {promoDiscountItems}

      {/* Display associated tax items */}
      {taxes?.map((tax, taxIndex) => (
        <div className="flex w-full justify-between text-sm text-black-light items-center">
          <div className="pl-8 pr-3">{tax.label || t("ticket.tax")}</div>
          <div className="whitespace-nowrap px-3">
            <Currency value={tax.amount} />
          </div>
        </div>
      ))}
    </>
  );
};

export default AdjustmentItem;
